// Messages for operator/marketing/CollectionPage (auto-merged by lib/i18n.ts).
export const en = {
  'operator.marketing_cms.collection_head': '{label} — Website content',
  'operator.marketing_cms.collection_desc':
    'Add, edit, reorder or remove items. Changes go live only when published.',
  'operator.marketing_cms.collection_empty': 'No items yet. Use “Add item” to create one.',
  'operator.marketing_cms.collection_item': 'Item {n}',
  'operator.marketing_cms.add_item': 'Add item',
  'operator.marketing_cms.delete_item': 'Delete item',
  'operator.marketing_cms.move_up': 'Move up',
  'operator.marketing_cms.move_down': 'Move down',
  'operator.marketing_cms.all_locales': 'all languages',
}

export const zhTW = {
  'operator.marketing_cms.collection_head': '{label} — 網站內容',
  'operator.marketing_cms.collection_desc': '新增、編輯、排序或移除項目。變更需發布後才會上線。',
  'operator.marketing_cms.collection_empty': '尚無項目。點「新增項目」建立一筆。',
  'operator.marketing_cms.collection_item': '項目 {n}',
  'operator.marketing_cms.add_item': '新增項目',
  'operator.marketing_cms.delete_item': '刪除項目',
  'operator.marketing_cms.move_up': '上移',
  'operator.marketing_cms.move_down': '下移',
  'operator.marketing_cms.all_locales': '所有語言',
}
